import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "tabs" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
    key: 0,
    class: "ytd-note"
};
const _hoisted_4 = { class: "chart-container" };
const _hoisted_5 = { class: "chart-row" };
const _hoisted_6 = { class: "chart-axis" };
const _hoisted_7 = { class: "chart-legend" };
const _hoisted_8 = {
    key: 0,
    class: "legend-item"
};
const _hoisted_9 = {
    key: 1,
    class: "legend-item"
};
const _hoisted_10 = {
    key: 1,
    class: "coverage"
};
const _hoisted_11 = { class: "coverage-top" };
const _hoisted_12 = { class: "coverage-text" };
const _hoisted_13 = {
    key: 0,
    class: "coverage-tick"
};
const _hoisted_14 = {
    key: 1,
    class: "coverage-last"
};
const _hoisted_15 = {
    key: 2,
    class: "view-payslip-wrap"
};
const _hoisted_16 = { key: 1 };
const _hoisted_17 = { class: "tax-year-title" };
const _hoisted_18 = { class: "tax-form-list" };
const _hoisted_19 = { class: "form-explainers" };
const _hoisted_20 = { class: "form-explainer-kind" };
const _hoisted_21 = { class: "form-explainer-text" };
const _hoisted_22 = { class: "form-explainer-when" };
const _hoisted_23 = {
    key: 0,
    class: "payslip-list-employer"
};
const _hoisted_24 = { class: "tax-form-list" };
import { ref, computed, onMounted, getCurrentInstance, watch, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { BarChart } from 'echarts/charts';
import { GridComponent } from 'echarts/components';
import VChart from 'vue-echarts';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useWhatsApp } from '@/composables/useWhatsApp';
import { useRestoreScroll } from '@/composables/useRestoreScroll';
import { usePayslips } from '@/composables/usePayslips';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import AiChatBanner from './elements/AiChatBanner.vue';
import WhatsAppPromoCard from './elements/WhatsAppPromoCard.vue';
import WhatsAppEnableDrawer from './elements/WhatsAppEnableDrawer.vue';
import DocumentListItem from './elements/DocumentListItem.vue';
import SimpleDrawerPanel from './elements/SimpleDrawerPanel.vue';
import TaxCodeCard from './elements/TaxCodeCard.vue';
import PayslipBreakdown from './elements/PayslipBreakdown.vue';
import { formatDate } from '@/utils/payslips';
import { useDarkMode } from '@/composables/useDarkMode';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PayslipsPage',
    setup(__props) {
        const { isDarkMode } = useDarkMode();
        use([CanvasRenderer, BarChart, GridComponent]);
        const chartRef = ref(null);
        const chartScrollRef = ref(null);
        // Start on the latest month; also re-runs when the chart remounts after switching back from the Tax docs tab.
        watch(chartScrollRef, el => {
            if (el)
                el.scrollLeft = el.scrollWidth;
        }, { flush: 'post' });
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const instance = getCurrentInstance();
        const whatsAppNumber = instance?.appContext.config.globalProperties.$whatsAppNumber || '';
        const whatsAppPromoCard = ref(null);
        const whatsAppEnableDrawer = ref(null);
        const { handleWhatsAppAction, handleEnableWhatsApp, handleWhatsAppEnableDone, handleWhatsAppDrawerClosed } = useWhatsApp({
            whatsAppPromoCard,
            whatsAppEnableDrawer,
            whatsAppNumber,
        });
        const { hmrcForms, loaded, selectedKey, months, coverage, selectedIndex, selectedMonth, selectedPayslip, selectedMonthName, selectedMonthOnly, selectedTaxYear, selectedTaxCode, selectedEstimate, monthOnMonthText, yearToDateNote, coverageText, lastPayslipText, monthNameOf, legendSeries, hasMissingMonths, hasEstimates, chartOption, onChartClick, payslipButtonText, selectedMonthByEmployer, hmrcByYear, formExplainers, aiContextFor, aiPromptsFor, loadPayslips, } = usePayslips({ isDark: () => isDarkMode.value });
        const aiContext = computed(() => aiContextFor(activeTab.value));
        const aiPrompts = computed(() => aiPromptsFor(activeTab.value));
        const activeTab = computed({
            get: () => state.payslipsTab,
            set: (tab) => { state.payslipsTab = tab; },
        });
        const tabs = [
            { key: 'pay', label: 'Pay' },
            { key: 'tax', label: 'Tax docs' },
        ];
        const tabRefs = ref([]);
        const tabActiveLeft = ref(4);
        const tabActiveWidth = ref(0);
        function setTabRef(index, el) {
            tabRefs.value[index] = el;
        }
        function updateTabActivePosition() {
            const activeIndex = tabs.findIndex(t => t.key === activeTab.value);
            const el = tabRefs.value[activeIndex];
            if (el) {
                tabActiveLeft.value = el.offsetLeft;
                tabActiveWidth.value = el.offsetWidth;
            }
        }
        watch(activeTab, () => {
            nextTick(updateTabActivePosition);
        });
        // The payslip list lives in app state so back (and leaving and returning) keeps it (DEV-147).
        const payslipListOpen = computed({
            get: () => state.payslipsListOpen,
            set: (open) => { state.payslipsListOpen = open; },
        });
        const scroll = useRestoreScroll();
        // The list drawer only reopens when coming back to it, not on a fresh visit.
        if (!scroll.returning)
            state.payslipsListOpen = false;
        const taxCodeOpen = ref(false);
        const chatBanner = ref(null);
        const monthSlots = computed(() => months.value.map(m => ({ key: m.key, label: m.label })));
        function askAboutTaxCode(question) {
            taxCodeOpen.value = false;
            chatBanner.value?.openChat(question);
        }
        // "Add missing" selects the oldest missing month so the card shows it, then opens the upload flow.
        function addMissing() {
            if (coverage.value?.oldestMissingKey)
                selectedKey.value = coverage.value.oldestMissingKey;
            handleWhatsAppAction();
        }
        // £ axis pinned beside the scrolling bars, on the same explicit scale.
        const axisOption = computed(() => {
            const option = chartOption.value;
            return {
                animation: false,
                grid: option.grid,
                xAxis: { ...option.xAxis, show: false },
                yAxis: { ...option.yAxis, splitLine: { show: false }, axisLabel: { ...option.yAxis.axisLabel, show: true, inside: true, margin: 0 } },
                series: [{ type: 'bar', data: [], silent: true }],
            };
        });
        // One handler covers bar clicks and empty-column clicks: map the click x to the nearest month.
        function onZrClick(event) {
            onChartClick(chartRef.value, event);
        }
        // Keep the selected bar in view when the month changes from the picker or a swipe.
        watch(selectedIndex, idx => {
            const el = chartScrollRef.value;
            if (!el || idx < 0)
                return;
            const col = el.scrollWidth / months.value.length;
            const left = idx * col;
            if (left < el.scrollLeft || left + col > el.scrollLeft + el.clientWidth) {
                el.scrollTo({ left: left - (el.clientWidth - col) / 2, behavior: 'smooth' });
            }
        });
        let touchStart = null;
        function onCardTouchStart(e) {
            touchStart = { x: e.touches[0].clientX, y: e.touches[0].clientY };
        }
        // Horizontal swipe on the month card moves to the previous / next month.
        function onCardTouchEnd(e) {
            if (!touchStart)
                return;
            const dx = e.changedTouches[0].clientX - touchStart.x;
            const dy = e.changedTouches[0].clientY - touchStart.y;
            touchStart = null;
            if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy))
                return;
            const next = months.value[selectedIndex.value + (dx < 0 ? 1 : -1)];
            if (next)
                selectedKey.value = next.key;
        }
        // "Add" uses the WhatsApp flow until in-app upload (DEV-144) exists.
        function onPayslipButton() {
            const list = selectedMonth.value?.payslips || [];
            if (!list.length)
                handleWhatsAppAction();
            else if (list.length > 1)
                payslipListOpen.value = true;
            else
                router.push(`/documents/${list[0].original.id}`);
        }
        onMounted(() => {
            getCustomer(() => { });
            loadPayslips(() => scroll.restore());
            nextTick(updateTabActivePosition);
        });
        return (_ctx, _cache) => {
            const _component_v_progress_linear = _resolveComponent("v-progress-linear");
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "Payslips & Tax" }),
                _createElementVNode("div", {
                    class: _normalizeClass(["payslips-page", { dark: _unref(isDarkMode) }])
                }, [
                    _createVNode(AiChatBanner, {
                        ref_key: "chatBanner",
                        ref: chatBanner,
                        prompts: aiPrompts.value,
                        dynamicSuggestions: true,
                        context: aiContext.value,
                        prefill: true
                    }, null, 8, ["prompts", "context"]),
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", {
                            class: "tab-active-bg",
                            style: _normalizeStyle({ left: tabActiveLeft.value + 'px', width: tabActiveWidth.value + 'px' })
                        }, null, 4),
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab, index) => {
                            return _createElementVNode("button", {
                                key: tab.key,
                                ref_for: true,
                                ref: el => setTabRef(index, el),
                                class: _normalizeClass(["tab", { 'tab--selected': activeTab.value === tab.key }]),
                                onClick: ($event) => (activeTab.value = tab.key)
                            }, _toDisplayString(tab.label), 11, _hoisted_2);
                        }), 64))
                    ]),
                    (activeTab.value === 'pay')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_unref(loaded))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_unref(yearToDateNote))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(yearToDateNote)), 1))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("div", _hoisted_5, [
                                            _createElementVNode("div", _hoisted_6, [
                                                _createVNode(_unref(VChart), {
                                                    option: axisOption.value,
                                                    style: { height: '100%', width: '100%' },
                                                    autoresize: ""
                                                }, null, 8, ["option"])
                                            ]),
                                            _createElementVNode("div", {
                                                ref_key: "chartScrollRef",
                                                ref: chartScrollRef,
                                                class: "chart-scroll"
                                            }, [
                                                _createVNode(_unref(VChart), {
                                                    ref_key: "chartRef",
                                                    ref: chartRef,
                                                    option: _unref(chartOption),
                                                    style: _normalizeStyle({ height: '100%', width: `max(100%, ${_unref(months).length * 56}px)` }),
                                                    autoresize: "",
                                                    "onZr:click": onZrClick
                                                }, null, 8, ["option", "style"])
                                            ], 512)
                                        ]),
                                        _createElementVNode("div", _hoisted_7, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(legendSeries), (s) => {
                                                return (_openBlock(), _createElementBlock("span", {
                                                    key: s.key,
                                                    class: "legend-item"
                                                }, [
                                                    _createElementVNode("span", {
                                                        class: "legend-swatch",
                                                        style: _normalizeStyle({ background: `var(${s.cssVar})` })
                                                    }, null, 4),
                                                    _createTextVNode(_toDisplayString(s.label), 1)
                                                ]));
                                            }), 128)),
                                            (_unref(hasEstimates))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _cache[3] || (_cache[3] = [
                                                    _createElementVNode("span", { class: "legend-swatch legend-swatch--estimated" }, null, -1),
                                                    _createTextVNode("Est. ")
                                                ])))
                                                : _createCommentVNode("", true),
                                            (_unref(hasMissingMonths))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _cache[4] || (_cache[4] = [
                                                    _createElementVNode("span", { class: "legend-swatch legend-swatch--missing" }, null, -1),
                                                    _createTextVNode("Missing ")
                                                ])))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    (_unref(coverage))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                            _createElementVNode("div", _hoisted_11, [
                                                _createElementVNode("span", _hoisted_12, [
                                                    _createTextVNode(_toDisplayString(_unref(coverageText)), 1),
                                                    (_unref(coverage).held >= _unref(coverage).expected)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, " ✓"))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ]),
                                            (_unref(coverage).held < _unref(coverage).expected)
                                                ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                                                    key: 0,
                                                    class: "coverage-bar",
                                                    "model-value": _unref(coverage).expected ? (_unref(coverage).held / _unref(coverage).expected) * 100 : 100,
                                                    height: "4",
                                                    rounded: ""
                                                }, null, 8, ["model-value"]))
                                                : _createCommentVNode("", true),
                                            (_unref(lastPayslipText))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(lastPayslipText)), 1))
                                                : _createCommentVNode("", true)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createVNode(_Transition, {
                                        name: "card-fade",
                                        mode: "out-in"
                                    }, {
                                        default: _withCtx(() => [
                                            (_unref(selectedMonth))
                                                ? (_openBlock(), _createBlock(PayslipBreakdown, {
                                                    key: _unref(selectedMonth).key,
                                                    class: "breakdown-section",
                                                    payslip: _unref(selectedPayslip),
                                                    monthName: _unref(selectedMonthName),
                                                    monthOnly: _unref(selectedMonthOnly),
                                                    payslipCount: _unref(selectedMonth).payslips.length,
                                                    estimate: _unref(selectedEstimate),
                                                    estimateSource: _unref(selectedEstimate) ? _unref(monthNameOf)(_unref(selectedEstimate).sourceKey) : '',
                                                    monthOnMonth: _unref(monthOnMonthText),
                                                    taxCodeVariant: _unref(selectedTaxCode)?.variant,
                                                    dark: _unref(isDarkMode),
                                                    onTaxCode: _cache[0] || (_cache[0] = ($event) => (taxCodeOpen.value = true)),
                                                    onTouchstartPassive: onCardTouchStart,
                                                    onTouchend: onCardTouchEnd
                                                }, null, 8, ["payslip", "monthName", "monthOnly", "payslipCount", "estimate", "estimateSource", "monthOnMonth", "taxCodeVariant", "dark"]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    }),
                                    (_unref(selectedMonth))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                            _createVNode(MGButton, {
                                                text: _unref(payslipButtonText),
                                                fullWidth: true,
                                                arrow: true,
                                                onClick: onPayslipButton
                                            }, null, 8, ["text"])
                                        ]))
                                        : _createCommentVNode("", true)
                                ], 64))
                                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _createVNode(_component_v_skeleton_loader, {
                                        type: "card",
                                        loading: true
                                    })
                                ]))
                        ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_unref(hmrcForms).length === 0)
                                ? (_openBlock(), _createBlock(WhatsAppPromoCard, {
                                    key: 0,
                                    class: "whatsapp-promo",
                                    ref_key: "whatsAppPromoCard",
                                    ref: whatsAppPromoCard,
                                    closable: false,
                                    title: "No tax docs yet",
                                    subtitle: "Add your P60, P45 or P11D and we'll file them by tax year and explain what they mean.",
                                    buttonText: "Send via WhatsApp",
                                    onAction: _unref(handleWhatsAppAction)
                                }, {
                                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                                        _createElementVNode("div", { class: "promo-tip" }, "Tip: forward the PDF from your payroll email for the best results.", -1)
                                    ])),
                                    _: 1
                                }, 8, ["onAction"]))
                                : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(hmrcByYear), (group) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: group.year,
                                    class: "tax-year-section"
                                }, [
                                    _createElementVNode("h2", _hoisted_17, _toDisplayString(group.year), 1),
                                    _createElementVNode("div", _hoisted_18, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.forms, (form) => {
                                            return (_openBlock(), _createBlock(DocumentListItem, {
                                                key: form.id,
                                                company: form.kind,
                                                fileName: form.employer,
                                                date: form.dateString,
                                                documentType: form.headline,
                                                onClick: ($event) => (_unref(router).push(`/documents/${form.id}`))
                                            }, null, 8, ["company", "fileName", "date", "documentType", "onClick"]));
                                        }), 128)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.missing, (kind) => {
                                            return (_openBlock(), _createBlock(DocumentListItem, {
                                                key: kind,
                                                class: "missing-form",
                                                company: `${kind} ${group.year}`,
                                                fileName: "Not added yet, tap to add",
                                                datePrefix: "",
                                                onClick: _unref(handleWhatsAppAction)
                                            }, null, 8, ["company", "onClick"]));
                                        }), 128))
                                    ])
                                ]));
                            }), 128)),
                            _createElementVNode("div", _hoisted_19, [
                                _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "tax-year-title" }, "What are these forms?", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formExplainers), (f) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: f.kind,
                                        class: "form-explainer"
                                    }, [
                                        _createElementVNode("div", _hoisted_20, _toDisplayString(f.kind), 1),
                                        _createElementVNode("div", _hoisted_21, _toDisplayString(f.text), 1),
                                        _createElementVNode("div", _hoisted_22, _toDisplayString(f.when), 1)
                                    ]));
                                }), 128))
                            ])
                        ], 64))
                ], 2),
                _createVNode(SimpleDrawerPanel, {
                    modelValue: taxCodeOpen.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((taxCodeOpen).value = $event)),
                    title: "Your tax code",
                    closeButton: true
                }, {
                    default: _withCtx(() => [
                        (_unref(selectedTaxCode))
                            ? (_openBlock(), _createBlock(TaxCodeCard, {
                                key: 0,
                                code: _unref(selectedPayslip).taxCode,
                                taxYear: _unref(selectedTaxYear),
                                onAsk: askAboutTaxCode
                            }, null, 8, ["code", "taxYear"]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(SimpleDrawerPanel, {
                    modelValue: payslipListOpen.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((payslipListOpen).value = $event)),
                    title: `${_unref(selectedMonthOnly)} payslips`,
                    closeButton: true
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedMonthByEmployer), (group) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: group.employer,
                                class: "payslip-list-group"
                            }, [
                                (_unref(selectedMonthByEmployer).length > 1)
                                    ? (_openBlock(), _createElementBlock("h3", _hoisted_23, _toDisplayString(group.employer), 1))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_24, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.payslips, (p) => {
                                        return (_openBlock(), _createBlock(DocumentListItem, {
                                            key: p.original.id,
                                            company: p.employer,
                                            fileName: `Net pay ${_unref(state).formatter.format(p.netPay)}`,
                                            datePrefix: "Paid",
                                            date: p.datePaid ? _unref(formatDate)(p.datePaid) : '',
                                            onClick: ($event) => (_unref(router).push(`/documents/${p.original.id}`))
                                        }, null, 8, ["company", "fileName", "date", "onClick"]));
                                    }), 128))
                                ])
                            ]));
                        }), 128))
                    ]),
                    _: 1
                }, 8, ["modelValue", "title"]),
                _createVNode(WhatsAppEnableDrawer, {
                    ref_key: "whatsAppEnableDrawer",
                    ref: whatsAppEnableDrawer,
                    phoneNumber: _unref(state).customer?.person?.mobilePhone || '',
                    onEnable: _unref(handleEnableWhatsApp),
                    onDone: _unref(handleWhatsAppEnableDone),
                    onClosed: _unref(handleWhatsAppDrawerClosed)
                }, null, 8, ["phoneNumber", "onEnable", "onDone", "onClosed"])
            ], 64));
        };
    }
});
